module.exports = __webpack_public_path__ + "background.f747855.png";